import { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import api, { errorMessage } from '../lib/api';

export const usePackageQuote = (pickupLocation, deliveryLocation) => {
  const { coverage, packagePricingRevision } = useApp();
  const [result, setResult] = useState(null);
  const requestKey = JSON.stringify({ pickupLocation, deliveryLocation, packagePricingRevision, areas: coverage.map((a) => [a.id, a.active, a.geometry, a.packagePickupFee, a.packageDropoffFee]) });
  useEffect(() => {
    let cancelled = false;
    const { pickupLocation: pickup, deliveryLocation: delivery } = JSON.parse(requestKey);
    if (!pickup || !delivery) return undefined;
    const timer = setTimeout(async () => {
      try { const quote = await api.packageQuote({ pickupLocation: pickup, deliveryLocation: delivery }); if (!cancelled) setResult({ requestKey, quote }); }
      catch (e) { if (!cancelled) setResult({ requestKey, error: errorMessage(e) }); }
    }, 200);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [requestKey]);
  return result?.requestKey === requestKey ? result : { quote: null, error: null };
};